import { useCallback } from "react";
import { clsx } from "clsx";
import "./Tabs.scss";

type TabKey = string;
type TTabSize = "l" | "m" | "s";

export interface ITab {
  label: string;
  value: TabKey;
}

interface IProps {
  value: TabKey;
  list: ITab[];
  size?: TTabSize;
  onChange: (key: TabKey) => void;
}

export const Tabs = (props: IProps) => {
  const { list, onChange, value, size = "l" } = props;

  const handleClick = useCallback((key: TabKey) => () => {
    if (key === value) {
      return;
    }

    onChange(key);
  }, [onChange, value]);

  const tabs = list.map(tab => {
    return (
      <button
        type="button"
        key={tab.value}
        className={clsx("tab", `tab_${size}`, tab.value === value && "active")}
        onClick={handleClick(tab.value)}
        aria-label={`${tab.label} button`}
      >
        {tab.label}
      </button>
    );
  });

  return (
    <div className="tabs">
      {tabs}
    </div>
  );
};
